module.exports = __webpack_public_path__ + "media/app/assets/races/mag'har_orc_male-230aa4f9290c174c7b1f8d4fdd642e64.png";